/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type models_SalesChannelCreateRequest = {
    config?: any;
    description?: Record<string, string>;
    enabled?: boolean;
    name: Record<string, string>;
    position?: number;
    slug: string;
    type: models_SalesChannelCreateRequest.type;
};
export namespace models_SalesChannelCreateRequest {
    export enum type {
        WEB = 'web',
        POS = 'pos',
        AGENCY = 'agency',
        MARKETING = 'marketing',
        VNPAY = 'vnpay',
        ZALOPAY = 'zalopay',
    }
}

